<template>
    <router-view/>
</template>

<script>
import VueQr from 'vue-qr'
import CryptoJS from 'crypto-js'
import commonApi from './commonData/commonApi'
export default {
  name: 'App',
  components:{
    VueQr
  },
  data () {
    return {
    }
  },
   created () {   
       //在页面加载时读取localStorage里的状态信息
       if (window.localStorage.getItem('text')) {
          //this.$store.replaceState()替换 store 的根状态
          this.$store.replaceState(Object.assign({}, this.$store.state,commonApi.Decrypt(window.localStorage.getItem('text'),"$3r6h(K)2d7j21!^")))
      }
          //在页面刷新时将vuex里的信息保存到localStorage里
          window.addEventListener('beforeunload', () => {
          window.localStorage.setItem('text',commonApi.Encrypt(this.$store.state,"$3r6h(K)2d7j21!^"))
      })
  }
}
</script>

<style>
#app {
  font-family: -apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
*{
  /* overflow-y: overlay; */
  margin: 0;
  padding: 0;
    cursor:default;
}

</style>



// WEBPACK FOOTER //
// src/App.vue